module.exports = __webpack_public_path__ + "img/weixin2.392c1558.png";